/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
/* eslint-disable no-alert */
/* eslint-disable no-restricted-globals */
import Vue from 'vue';
import Router from 'vue-router';
import RouterViewPage from '@/views/RouterViewPage.vue';
import Chat from '@/views/admin/chat/Chat.vue';
import md from '@/routes/middlewares';
import store from '@/store/index';
import routes from './routes';

const pageWithFormular = ['flowDiagram', 'info', 'clientsConfiguration', 'siteInfo', 'user', 'serviceProviderInfo', 'siteEditTemplate'];
Vue.use(Router);
function scrollBehavior(_, __, savedPosition) {
    return savedPosition ?? { y: 0 };
}
/**
 * Note that when defining routes, you can use "atLeastNeededRoles" meta property,
 * an array of roles. If the member has at least one of the role one the type, he can go to the page.
 * You can also use "everyNeededPermission" meta property that will check that the user has every permissions contained in the array
 *
 * @type {VueRouter}
 */
const router = new Router({ mode: 'history', routes, scrollBehavior });

const translations = {
    modal: {
        quitWithoutSave: {
            title: {
                en: 'Warning',
                fr: 'Attention',
            },
            message: {
                en: 'You are about to leave without saving, continue ?',
                fr: 'Vous êtes sur le point de partir sans sauvegarder, continuer ?',
            },
        },
    },
};


/** Middlewares Implementation * */

/**
 * Run the specified middlewares before going execute the next function of the router
 * @param {Object} context - the context of the route with to, from and next
 * @param {Array} middlewares - list of the middlewares to execute
 * @param {index} index - the index of the middleware to execute in the array
 */
const runMiddlewares = async (context, middlewares, index) => {
    // Execute the middleware
    const hasNexted = await middlewares[index](context);

    // If the next function was executed, we stop the middleware.
    if (hasNexted) {
        return null;
    }

    // If there are more middlewares to execute, we are executing them
    if (middlewares.length - 1 > index) {
        return runMiddlewares(context, middlewares, index + 1);
    }

    // Run the "next" function of the router when all middlewares were executed.
    return context.next();
};
// Before each navigation (to a route) we are running the specified middlewares (if there is any)
router.beforeEach(async (to, from, next) => {
    const userLang = store.getters.lang?.toLowerCase();
    // Will find the middlwares of current route and parents
    let middlewares = [md.resetInfo];
    to.matched.forEach(route => {
        if (route.meta && route.meta.middlewares) {
            middlewares = middlewares.concat(route.meta.middlewares);
        }
    });
    // If there is any middlewares, we are running them
    if (middlewares.length > 0) {
        if (pageWithFormular.includes(from.name) && store.state.preventQuitFormular && store.state.preventQuitFormular.value) {
            const confirmMessage = translations.modal.quitWithoutSave.message[userLang];
            if (confirm(confirmMessage)) {
                next();
                store.dispatch('disablePreventQuitFormular');
            } else {
                return;
            }
        } else {
            store.dispatch('disablePreventQuitFormular');
        }

        const context = {
            to,
            from,
            store,
            next: arg => { // Wrapping the original next router function to return true if used.
                next(arg);
                return true;
            },
        };

        await runMiddlewares(context, middlewares, 0);
    } else {
        next();
    }
});

const DISABLE_CYPRESS_FOR_CHAT = typeof window.Cypress === 'undefined';


router.afterEach(to => {
    if (DISABLE_CYPRESS_FOR_CHAT) {
        // env variable are string
        if (process.env.VUE_APP_ENV_ENABLE_CHAT === 'true') {
            const shouldLoadCrisp = !to.path.includes('/chatOptions');
            if (shouldLoadCrisp) {
                window.$crisp.push(['do', 'chat:show']);
            } else {
                window.$crisp.push(['do', 'chat:hide']);
            }
        }
    }
});


function createChatBeforeEnterHook(access) {
    return async (to, from, next) => {
        store.dispatch('loading/showLoading');
        try {
            const response = await store.$rq.getChatConversations(access.websiteId, access.chatName);
            const conversations = response.data;
            const conversationsUserMap = conversations.reduce((map, conversation) => {
                const firstUser = conversation.users[1];
                map[conversation.roomId] = firstUser;
                return map;
            }, {});
            to.params.conversations = conversations;
            to.params.conversationsUserMap = conversationsUserMap;
            to.params.chatName = access.chatName;
            to.params.websiteId = access.websiteId;

            next();
        } catch (error) {
            next();
        } finally {
            store.dispatch('loading/hideLoading');
        }
    };
}


function addChatRoute(router, access, routeName) {
    router.addRoutes([{
        path: '/administration/chatOptions',
        component: RouterViewPage,
        children: [{
            path: access.chatName,
            name: routeName,
            component: Chat,
            beforeEnter: createChatBeforeEnterHook(access),
            meta: {
                middlewares: [md.isAdmin],
            },
        }],
    }]);
}

function getExistingRouteNames(router) {
    return router.options.routes.flatMap(route => (route.children ? route.children.map(child => child.name) : []));
}

async function addChatRouteLogic(router, access, existingRouteNames) {
    const routeName = access.chatName;

    if (existingRouteNames.includes(routeName)) {
        return;
    }

    addChatRoute(router, access, routeName);
    await store.dispatch('dynamicRoutes/addChatRoute', {
        title: access.chatName,
        path: { name: routeName },
    });
}


async function handleAdministrationRoute(router) {
    const chatAccesses = await store.$rq.getChatAccesses();
    const existingRouteNames = getExistingRouteNames(router);
    const promises = chatAccesses.data.chatAccesses.map(access => addChatRouteLogic(router, access, existingRouteNames));
    await Promise.all(promises);
}

/* eslint-disable no-param-reassign */
router.beforeEach(async (to, from, next) => {
    let chatCondition = true;
    if (!DISABLE_CYPRESS_FOR_CHAT) {
        chatCondition = false;
    }

    // env variable are string
    if (process.env.VUE_APP_ENV_ENABLE_CHAT === 'false') {
        chatCondition = false;
    }

    if (!to.path.startsWith('/administration')) {
        chatCondition = false;
    }
    if (chatCondition) {
        await handleAdministrationRoute(router, to);
        next();
    } else {
        next();
    }
});


export default router;
